/** @jsx jsx */
import { jsx } from '@emotion/react'
import { formacaoQuePrepara } from '../assets/styles/FormacaoQuePrepara.styles'
import { Col, Container, Row } from 'react-bootstrap'
import IconEnsinoTrilingue from '../assets/images/LP-arabe/ensino-trilingue.svg'
import IconTRR from '../assets/images/LP-arabe/tradicao-respeito-religiosidade.svg'
import IconEducacaoEtica from '../assets/images/LP-arabe/educao-etica.svg'

const FormacaoQuePreparaContent = () => {
  return (
    <section id='sobre' css={formacaoQuePrepara}>
      <Container>
        <Row data-aos="fade-down" data-aos-delay="500" className='title-sec'>
          <Col lg={6} md={6} sm={12}>
            <h2>Formação que prepara para <span>inspirar, liderar e prosperar</span></h2>
          </Col>
          <Col lg={1} md={1} sm={12} />
          <Col lg={5} md={5} sm={12}>
            <p>Mais que uma escola: um espaço de desenvolvimento integral, onde os alunos crescem com identidade, propósito e valores.</p>
          </Col>
        </Row>
        <Row data-aos="fade-down" data-aos-delay="600" className='title-sec'>
          <Col lg={4} md={4} sm={12}>
            <div className='box-1'>
              <img src={IconEnsinoTrilingue}  />
              <h3>Ensino trilíngue</h3>
              <p>Árabe e inglês desde os primeiros anos, com aulas diárias de português.</p>
            </div>
          </Col>
          <Col lg={4} md={4} sm={12}>
            <div className='box-2'>
              <img src={IconTRR}  />
              <h3>Tradição, respeito e religiosidade</h3>
              <p>Valorização da cultura árabe e dos princípios islâmicos, sob a orientação da Mesquita de Foz e do CCBI.</p>
            </div>
          </Col>
          <Col lg={4} md={4} sm={12}>
            <div className='box-1'>
              <img src={IconEducacaoEtica}  />
              <h3>Educação ética e socioemocional</h3>
              <p>Formação de caráter e fortalecimento das relações familiares e amizades.</p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>

  )
}

export default FormacaoQuePreparaContent
